module.exports = __webpack_public_path__ + "img/b.ae9fc90b.png";